import { Carousel } from '@gik/ui';
import React from 'react';
import Slider, { Settings } from 'react-slick';
import ArticleLink from '../models/ArticleLink';
import ArticleLinkCard, { ArticleLinkCardStyle } from './ArticleLinkCard';

interface ArticleLinkCardCarouselProps {
  articleLinks: ArticleLink[];
}

export default class ArticleLinkCardCarousel extends React.PureComponent<ArticleLinkCardCarouselProps> {
  render() {
    const settings: Settings = {
      dots: true,
      fade: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 20000,
      pauseOnHover: true,
      pauseOnDotsHover: true,
    };
    return (
      <div className="article-link-card-carousel">
        <Carousel {...settings} arrowButtonSize="lg">
          {this.props.articleLinks.map(articleLink => (
            <ArticleLinkCard
              key={articleLink.title}
              articleLink={articleLink}
              cardStyle={ArticleLinkCardStyle.carousel}
              headingLevel={2}
            />
          ))}
        </Carousel>
      </div>
    );
  }
}
